import { useTheme } from "../ThemeContext";
import { useState, useEffect, useCallback } from "react";
import T from "../i18n";

const API = "https://mixupbr.com.br/api";

export default function Entregadores({ lojaId, lang }) {
  const { theme: C } = useTheme();
  const _ = (k) => T(lang, k);

  const [entregadores, setEntregadores] = useState([]);
  const [gruposLoja, setGruposLoja] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busca, setBusca] = useState("");
  const [totalFixos, setTotalFixos] = useState(0);
  const [totalOnline, setTotalOnline] = useState(0);
  const [toggling, setToggling] = useState(null);
  const [toast, setToast] = useState(null);

  const notify = (msg, ok = true) => { setToast({ msg, ok }); setTimeout(() => setToast(null), 2500); };

  const fetchEntregadores = useCallback(async () => {
    try {
      const params = new URLSearchParams({ loja_id: lojaId || 1 });
      if (busca) params.append("busca", busca);
      const r = await fetch(`${API}/loja_entregadores/?${params}`);
      const d = await r.json();
      if (d.ok) {
        setEntregadores(d.dados || []);
        setGruposLoja(d.grupos || []);
        setTotalFixos(d.total_fixos || 0);
        setTotalOnline(d.total_online || 0);
      }
    } catch (e) { console.error(e); }
    setLoading(false);
  }, [lojaId, busca]);

  useEffect(() => { fetchEntregadores(); }, [fetchEntregadores]);

  // Polling a cada 15s pra atualizar status online
  useEffect(() => {
    const i = setInterval(fetchEntregadores, 15000);
    return () => clearInterval(i);
  }, [fetchEntregadores]);

  const toggleFixo = async (entId, novoFixo) => {
    setToggling(entId);
    try {
      await fetch(`${API}/loja_entregadores/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ loja_id: lojaId || 1, entregador_id: entId, fixo: novoFixo ? 1 : 0 }),
      });
      // Atualizar local
      setEntregadores(prev => prev.map(e => e.id === entId ? { ...e, fixo: novoFixo ? 1 : 0 } : e));
      setTotalFixos(prev => novoFixo ? prev + 1 : prev - 1);
      notify(novoFixo ? "Entregador marcado como fixo" : "Entregador removido dos fixos");
    } catch { notify("Erro ao atualizar", false); }
    setToggling(null);
  };

  const fixos = entregadores.filter(e => e.fixo == 1);
  const naoFixos = entregadores.filter(e => e.fixo != 1);

  return (
    <div style={{ animation: "fadeUp .4s ease-out", padding: 4 }}>

      {toast && (
        <div style={{ position: "fixed", top: 20, left: "50%", transform: "translateX(-50%)", zIndex: 999,
          background: toast.ok ? C.green : C.red, color: "#fff", padding: "12px 28px",
          borderRadius: 12, fontWeight: 700, fontSize: 14, animation: "slideDown .3s ease-out", whiteSpace: "nowrap" }}>
          {toast.msg}
        </div>
      )}

      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <div>
          <h1 style={{ fontFamily: "Plus Jakarta Sans", fontWeight: 800, fontSize: 28, marginBottom: 4 }}>Entregadores</h1>
          <p style={{ fontSize: 13, color: C.textMuted }}>Gerencie quais entregadores atendem sua loja</p>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <div style={{ padding: "8px 16px", borderRadius: 10, background: `${C.orange}15`, border: `1px solid ${C.orange}40` }}>
            <div style={{ fontSize: 20, fontWeight: 800, color: C.orange }}>{totalFixos}</div>
            <div style={{ fontSize: 10, color: C.textMuted }}>Fixos</div>
          </div>
          <div style={{ padding: "8px 16px", borderRadius: 10, background: `${C.greenLight}15`, border: `1px solid ${C.greenLight}40` }}>
            <div style={{ fontSize: 20, fontWeight: 800, color: C.greenLight }}>{totalOnline}</div>
            <div style={{ fontSize: 10, color: C.textMuted }}>Online</div>
          </div>
          <div style={{ padding: "8px 16px", borderRadius: 10, background: `${C.blue}15`, border: `1px solid ${C.blue}40` }}>
            <div style={{ fontSize: 20, fontWeight: 800, color: C.blue }}>{entregadores.length}</div>
            <div style={{ fontSize: 10, color: C.textMuted }}>Total</div>
          </div>
        </div>
      </div>

      {/* Info */}
      <div style={{ padding: 14, borderRadius: 12, background: `${C.orange}08`, border: `1px solid ${C.orange}25`, marginBottom: 16, fontSize: 13, color: C.textMuted, lineHeight: 1.5 }}>
        <strong style={{ color: C.orange }}>[TODOS] Chamar Entregadores</strong> — toca pra TODOS os entregadores online.<br />
        <strong style={{ color: C.orange }}>[FIXO] Entregador Fixo</strong> — toca APENAS pros marcados abaixo com o toggle laranja.
      </div>

      {/* Grupos da loja */}
      {gruposLoja.length > 0 && (
        <div style={{ display: "flex", gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
          {gruposLoja.map(g => (
            <div key={g.id} style={{ padding: "6px 14px", borderRadius: 8, background: "#8B5CF615", border: "1px solid #8B5CF640", fontSize: 12, fontWeight: 700, color: "#8B5CF6" }}>
              {g.nome} - {g.cidade}
            </div>
          ))}
        </div>
      )}
      {gruposLoja.length === 0 && !loading && (
        <div style={{ padding: 12, borderRadius: 10, background: `${C.red}08`, border: `1px solid ${C.red}25`, marginBottom: 12, fontSize: 13, color: C.red }}>
          Nenhum grupo vinculado a esta loja. Peça ao administrador para vincular grupos no cadastro da loja.
        </div>
      )}

      {/* Busca */}
      <div style={{ marginBottom: 16 }}>
        <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar por nome ou telefone..."
          style={{ width: "100%", padding: "9px 14px", borderRadius: 10, border: `1px solid ${C.border}`, background: C.card, color: C.text, fontSize: 13, outline: "none", fontFamily: "inherit" }} />
      </div>

      {loading ? (
        <div style={{ textAlign: "center", padding: 60, color: C.textMuted }}>
          <div style={{ width: 32, height: 32, border: `3px solid ${C.border}`, borderTopColor: C.red, borderRadius: "50%", animation: "spin .8s linear infinite", margin: "0 auto 12px" }} />
          Carregando entregadores...
        </div>
      ) : (
        <div>
          {/* Fixos primeiro */}
          {fixos.length > 0 && (
            <div style={{ marginBottom: 20 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
                <div style={{ width: 8, height: 8, borderRadius: "50%", background: C.orange }} />
                <span style={{ fontSize: 13, fontWeight: 800, color: C.orange }}>Fixos da sua loja</span>
                <span style={{ fontSize: 10, background: C.orange, color: "#fff", padding: "1px 8px", borderRadius: 10, fontWeight: 700 }}>{fixos.length}</span>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 10 }}>
                {fixos.map(e => (
                  <EntregadorCard key={e.id} e={e} C={C} onToggle={toggleFixo} toggling={toggling} />
                ))}
              </div>
            </div>
          )}

          {/* Não fixos */}
          {naoFixos.length > 0 && (
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
                <span style={{ fontSize: 13, fontWeight: 800, color: C.textMuted }}>Outros entregadores</span>
                <span style={{ fontSize: 10, background: C.border, color: C.textMuted, padding: "1px 8px", borderRadius: 10, fontWeight: 700 }}>{naoFixos.length}</span>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 10 }}>
                {naoFixos.map(e => (
                  <EntregadorCard key={e.id} e={e} C={C} onToggle={toggleFixo} toggling={toggling} />
                ))}
              </div>
            </div>
          )}

          {entregadores.length === 0 && (
            <div style={{ textAlign: "center", padding: 60, color: C.textMuted }}>
              <div style={{ fontSize: 16, fontWeight: 800, color: C.textMuted, marginBottom: 10 }}>ENTREGADORES</div>
              <div style={{ fontSize: 14, fontWeight: 600 }}>Nenhum entregador neste grupo</div>
              <div style={{ fontSize: 12, marginTop: 4 }}>Verifique se os entregadores estao vinculados aos grupos desta loja no painel administrativo</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ── Card de entregador ──
function EntregadorCard({ e, C, onToggle, toggling }) {
  const isFixo = e.fixo == 1;
  const isOnline = e.online == 1;

  return (
    <div style={{
      background: C.card, borderRadius: 14, padding: "14px 16px",
      border: isFixo ? `2px solid ${C.orange}50` : `1px solid ${C.border}`,
      display: "flex", alignItems: "center", gap: 12,
      transition: "all .2s",
    }}>
      {/* Avatar */}
      <div style={{ position: "relative", flexShrink: 0 }}>
        <div style={{
          width: 48, height: 48, borderRadius: 12, overflow: "hidden",
          background: C.bg, display: "flex", alignItems: "center", justifyContent: "center",
          border: `2px solid ${isOnline ? C.greenLight : C.border}`,
        }}>
          {e.foto_url ? (
            <img src={e.foto_url.startsWith("http") ? e.foto_url : `https://mixupbr.com.br${e.foto_url}`}
              style={{ width: "100%", height: "100%", objectFit: "cover" }} alt="" />
          ) : (
            <span style={{ fontSize: 20, fontWeight: 800, color: C.textMuted }}>{(e.nome || "E")[0].toUpperCase()}</span>
          )}
        </div>
        {/* Online indicator */}
        <div style={{
          position: "absolute", bottom: -2, right: -2, width: 14, height: 14, borderRadius: "50%",
          background: isOnline ? C.greenLight : "#6B7280",
          border: `2px solid ${C.card}`,
        }} />
      </div>

      {/* Info */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 700, fontSize: 14, color: C.text, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          {e.nome}
        </div>
        <div style={{ fontSize: 11, color: C.textMuted, marginTop: 2 }}>
          {e.telefone || "—"}
        </div>
        <div style={{ display: "flex", gap: 4, marginTop: 4, flexWrap: "wrap" }}>
          {e.grupo_nome && (
            <span style={{ fontSize: 9, fontWeight: 700, color: "#8B5CF6", background: "#8B5CF615", padding: "1px 6px", borderRadius: 4 }}>
              {e.grupo_nome}
            </span>
          )}
          {e.cidade && (
            <span style={{ fontSize: 9, fontWeight: 700, color: C.blue, background: `${C.blue}15`, padding: "1px 6px", borderRadius: 4 }}>
              {e.cidade}
            </span>
          )}
          <span style={{
            fontSize: 9, fontWeight: 700,
            color: isOnline ? C.greenLight : "#6B7280",
            background: isOnline ? `${C.greenLight}15` : `${C.border}`,
            padding: "1px 6px", borderRadius: 4,
          }}>
            {isOnline ? "ONLINE" : "OFFLINE"}
          </span>
          {isFixo && (
            <span style={{ fontSize: 9, fontWeight: 700, color: C.orange, background: `${C.orange}15`, padding: "1px 6px", borderRadius: 4 }}>
              FIXO
            </span>
          )}
        </div>
      </div>

      {/* Toggle fixo */}
      <div onClick={() => onToggle(e.id, !isFixo)}
        style={{
          width: 48, height: 26, borderRadius: 13, cursor: "pointer", transition: "all .2s",
          background: isFixo ? C.orange : `${C.border}80`,
          position: "relative", flexShrink: 0,
          opacity: toggling === e.id ? 0.5 : 1,
        }}>
        <div style={{
          width: 22, height: 22, borderRadius: 11, background: "#fff",
          position: "absolute", top: 2,
          left: isFixo ? 24 : 2,
          transition: "left .2s",
          boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
        }} />
      </div>
    </div>
  );
}
